export const listComponentAliases = /* GraphQL */ `
  query ListComponentAliases($vendor: String!) {
    listComponentAliases(filter: { vendor: { eq: $vendor } }, limit: 1000) {
      items { id vendor ref refDisplay componentSku createdBy createdAt }
    }
  }
`;

export const createComponentAlias = /* GraphQL */ `
  mutation CreateComponentAlias($input: CreateComponentAliasInput!) {
    createComponentAlias(input: $input) { id ref componentSku }
  }
`;

export const listCatalogImportProfiles = /* GraphQL */ `
  query ListCatalogImportProfiles($vendor: String!) {
    listCatalogImportProfiles(filter: { vendor: { eq: $vendor } }, limit: 50) {
      items { id vendor name mapping updatedAt updatedBy }
    }
  }
`;

export const createCatalogImportProfile = /* GraphQL */ `
  mutation CreateCatalogImportProfile($input: CreateCatalogImportProfileInput!) {
    createCatalogImportProfile(input: $input) { id name mapping }
  }
`;

export const updateCatalogImportProfile = /* GraphQL */ `
  mutation UpdateCatalogImportProfile($input: UpdateCatalogImportProfileInput!) {
    updateCatalogImportProfile(input: $input) { id name mapping }
  }
`;
